<template>
  <div>
    <v-list-item>

      <v-list-item-avatar>
        <v-icon class='error' dark>mdi-email-outline</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class='font-weight-bold'>{{ email.action_date | shortDate }}</v-list-item-title>
        <v-list-item-text>
          <div v-if='email.description'>{{ 'Description: ' + email.description}}</div>

          <v-btn v-if='email.client' text :loading='loading' :disabled='loading' @click="openClient(email.client)">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open Client Record
          </v-btn>

          <v-btn v-if='email.estimate' text :loading='loading' :disabled='loading' @click="openEstimate(email.estimate)">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open Estimate
          </v-btn>

          <v-btn v-if='email.work_order' text :loading='loading' :disabled='loading' @click="openWorkOrder(email.work_order)">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open Work Order
          </v-btn>

          <v-btn v-if='email.invoice' text :loading='loading' :disabled='loading' @click="openInvoice(email.invoice)">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open Invoice
          </v-btn>

          <v-btn v-if='email.project' text :loading='loading' :disabled='loading' @click="openProject(email.project)">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open Project
          </v-btn>

          <v-btn v-if='email.subd_tracker' text :loading='loading' :disabled='loading' @click="openSUBD(email.subd_tracker)">
            <v-icon small left color='info'>mdi-open-in-new</v-icon>
            Open SUBD Tracker
          </v-btn>
        </v-list-item-text>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn fab text @click='showConfirm = true'>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <wc-confirm
      :showDialog='showConfirm'
      title='Clear this Alert?'
      saveText="Yes, clear it"
      @cancel='showConfirm = false'
      @confirm='clearAlert()'
      width='500'
    >
      <span>Please ensure you have resolved this issue before clearing this alert.<br><br>
        Clearing this alert does not delete the action tracker entry.<br>
        It can still be found on the appropriate page.
      </span>
    </wc-confirm>
  </div>
</template>

<script>
import trackerAPI from '@/api/tracker';
import estimatesAPI from '@/modules/estimates/api/estimates';
import projectsAPI from '@/modules/projects/api/projects';
import _ from 'lodash';

export default {
  name: 'wc-bounced-email-list-item',
  data: () => ({
    loading: false,
    showConfirm: false,
  }),
  props: {
    email: { required: true, type: Object }
  },
  methods: {
    clearAlert () {
      let tmp = _.cloneDeep(this.email)
      tmp.has_error = false
      trackerAPI.updateTracker(this.email.id, { has_error: false })
      this.showConfirm = false
      this.$emit('clearAlert', tmp)
    },
    async openEstimate(id) {
      this.loading = true
      let tmp = await estimatesAPI.getEstimates(id)
      let division = tmp.division_obj.division
      let div = division.toLowerCase()
      if (this.$route.path !== '/estimates/detail/' + id + '/' + div + '-overview') {
        this.$router.push({ name: division + 'Estimate', params: { id: id }})
      } else {
        alert("You're already on this estimate page")
      }
      this.loading = false
    },
    async openProject(id) {
      this.loading = true
      let tmp = await projectsAPI.getProject(id)
      let division = tmp.division_obj.division
      let div = division.toLowerCase()
      if (this.$route.path !== '/' + div + '/details/' + id + '/overview') {
        this.$router.push({ name: division + 'Overview', params: { id: id }})
      } else {
        alert("You're already on this project page")
      }
      this.loading = false
    },
    async openWorkOrder(id) {
      this.loading = true
      if (this.$route.path !== '/work-orders/wo-detail/' + id + '/overview') {
        this.$router.push({ name: 'WOOverview', params: { id: id }})
      } else {
        alert("You're already on this work order page")
      }
      this.loading = false
    },
    async openInvoice(id) {
      this.loading = true
      if (this.$route.path !== '/accounting/invoice-detail/' + id + '/overview') {
        this.$router.push({ name: 'InvoiceOverview', params: { id: id }})
      } else {
        alert("You're already on this invoice page")
      }
      this.loading = false
    },
    async openClient(id) {
      this.loading = true
      if (this.$route.path !== '/client-details/' + id + '/overview') {
        this.$router.push({ name: 'ClientOverview', params: { id: id }})
      } else {
        alert("You're already on this client page")
      }
      this.loading = false
    },
    async openSUBD(id) {
      this.loading = true
      if (this.$route.path !== '/irrigation/staging/' + id) {
        this.$router.push({ name: 'StartupDetails', params: { id: id }})
      } else {
        alert("You're already on this client page")
      }
      this.loading = false
    },

  }
}
</script>